var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3887",
    "data-name": "Group 3887",
    transform: "translate(-170 -3341)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 30,
    height: 30,
    rx: 3,
    transform: "translate(170 3341)",
    fill: "#142454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "twitter-x",
    d: "M14.175.75h2.761l-6.03,6.91L18,17.063H12.446l-4.35-5.7-4.978,5.7H.356l6.45-7.391L0,.75H5.7L9.628,5.962,14.176.75Zm-.967,14.656h1.53L4.863,2.319H3.223Z",
    transform: "translate(176 3347.094)",
    fill: "#f7f8f9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ee374b12f07d5be2fefabb9b0f95c9ac.svg";
export { ForwardRef as ReactComponent };